import { Component, Input } from '@angular/core';
import { WorkflowContact } from '@app/core/class';

@Component({
  selector: 'app-workflow-eletronic-signature-field',
  templateUrl: './eletronic-signature.component.html',
  styleUrls: ['../../../droppable-field.component.scss']
})
export class WorkflowEletronicSignatureFieldComponent {
  @Input()
  public contact: WorkflowContact;
}
